import GuestMenu from './GuestMenu';
import UserMenu from './UserMenu';

type Props = {
  isLoggedIn: boolean;
};

export default function UserArea({ isLoggedIn }: Props) {
  return (
    <div className="flex items-center space-x-3">
      {isLoggedIn ? <UserMenu /> : <GuestMenu />}
    </div>
  );
}
